import { createRoot } from 'react-dom/client'
import './index.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
// Initialize Sentry before anything else
import { initSentry } from './config/sentry.js'
initSentry();

import App from './App.jsx'
import store from './store.js'
import { Provider } from 'react-redux'
import { ToastProvider } from './modules/hooks/useToast.jsx'
import ServiceWorkerUpdateHandler from './components/ServiceWorkerUpdateHandler.jsx'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ToastProvider>
      <ServiceWorkerUpdateHandler />
      <App />
    </ToastProvider>
  </Provider>
)
